import { getCurrentJstDayjs, formatHyphenatedDate, convertJstDayjsFromDate } from '@/utils/date';

import type { Dayjs } from 'dayjs';

/**
 * カレンダー表示
 */
export type DailyCalendarAvailability = 'FINISHED' | 'EMPTY' | 'REALTIME' | 'REQUEST';

// 予約可能状態に残数僅かを追加した型を定義
export type AvailabilityStatus = DailyCalendarAvailability | 'REALTIME_FEW_REMAINING';

export const availabilityStatusList: AvailabilityStatus[] = ['FINISHED', 'EMPTY', 'REALTIME', 'REQUEST', 'REALTIME_FEW_REMAINING'];

/**
 * 過去の日付判定
 * @param vDayObj vカレンダーの日付
 * @returns {Boolean}過去か否か
 */
export const isPastDay = (day: Dayjs, now: Date): boolean => {
  const calendar = convertJstDayjsFromDate(day.toDate());
  const biginingOfToday = convertJstDayjsFromDate(now).startOf('day'); // 今日の00:00:00を取得する
  return calendar.isBefore(biginingOfToday);
};

/**
 * 特定の日付が過去の日付か否かを判定する
 * @param calendarDay 対象の日付
 * @returns {Boolean}過去の日付か否か
 */
export const getIsDisabledDate = (calendarDay: Dayjs): boolean => {
  return isPastDay(calendarDay, getCurrentJstDayjs().toDate());
};

/**
 * @param selectedDate YYYY-MM-DD
 * @param day 日付
 */
export const isSelectedDate = (selectedDate: string, day: Dayjs): boolean => {
  return selectedDate === formatHyphenatedDate(day);
};
/**
 * @param selectedDates YYYY-MM-DD
 * @param day 日付
 */
export const isSelectedDates = (selectedDates: string[], day: Dayjs): boolean => {
  return selectedDates.includes(formatHyphenatedDate(day));
};
